import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const CheckCircle: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.0353 0.0373505C10.319 0.0974465 9.7051 0.200143 9.03421 0.372127C6.15454 1.11027 3.66756 2.87105 2.02217 5.33667C-1.1579 10.102 -0.533371 16.4347 3.51598 20.484C4.48565 21.4537 5.54892 22.2077 6.79808 22.8115C10.5875 24.6433 15.088 24.3413 18.6 22.0197C21.1126 20.3587 22.8939 17.8566 23.6305 14.9534C23.8083 14.2527 23.9297 13.5042 23.9664 12.8812C23.9756 12.7257 23.9923 12.5927 24.0035 12.5858C24.0148 12.5789 24.024 12.3032 24.024 11.9732C24.024 11.6432 24.0147 11.3789 24.0034 11.3858C23.9922 11.3928 23.9755 11.272 23.9663 11.1173C23.8509 9.16057 23.1288 7.0615 21.9777 5.33667C20.3449 2.88989 17.8712 1.12899 15.024 0.386695C13.7486 0.0541985 12.3229 -0.0706735 11.0353 0.0373505ZM11.556 2.01783C9.30605 2.11357 7.13691 2.98121 5.43596 4.46578C5.15976 4.70686 4.63604 5.23306 4.41063 5.49601C3.1166 7.00541 2.29071 8.90777 2.06331 10.9028C2.02107 11.2734 2.00146 11.9613 2.01977 12.4313C2.07197 13.7719 2.39412 15.0688 2.97944 16.2947C3.48464 17.3527 4.05617 18.1674 4.88045 19.0044C6.04251 20.1844 7.35737 20.9961 8.94406 21.513C10.0531 21.8743 11.1771 22.0254 12.42 21.9804C14.6619 21.8991 16.8546 21.0261 18.564 19.5342C18.8401 19.2931 19.3639 18.7669 19.5893 18.504C20.8861 16.9913 21.7035 15.1069 21.9369 13.092C22.002 12.5297 22.002 11.4704 21.9369 10.908C21.7035 8.89316 20.8861 7.00868 19.5893 5.49601C19.2035 5.04593 18.5866 4.46101 18.0885 4.07283C16.5555 2.87816 14.4509 2.09871 12.5659 2.02755C12.38 2.02052 12.1686 2.01157 12.096 2.00763C12.0234 2.00369 11.7804 2.00828 11.556 2.01783ZM13.3185 10.6818L10.6694 13.9934L9.32463 12.6487C8.58497 11.9091 7.96896 11.304 7.95572 11.304C7.92437 11.304 6.55196 12.6769 6.55196 12.7082C6.55196 12.734 10.8019 16.992 10.8276 16.992C10.8495 16.992 17.5202 8.65059 17.5188 8.62498C17.5181 8.61344 17.2259 8.37181 16.8693 8.08801C16.5128 7.80421 16.1641 7.5266 16.0944 7.47111L15.9676 7.37021L13.3185 10.6818ZM0.0103968 12C0.0103968 12.3366 0.0137568 12.4743 0.0178848 12.306C0.0220128 12.1377 0.0220128 11.8623 0.0178848 11.694C0.0137568 11.5257 0.0103968 11.6634 0.0103968 12Z'
        fill={fill}
      />
    </svg>
  )
}

export default CheckCircle
